export default __webpack_public_path__ + "static/cybersecuritydiagram-e2c399d67b9aca2b671595dca01df447.jpg";